import React from 'react';
import T from 'prop-types';

import iconDictionary from '../../utils/iconDictionary';
import Message from '../Message';
import { StyledView } from './styledComponents';
import { pathnameDictionary } from './constants';

const errorStorm = iconDictionary('errorStorm');

const UnavailableFeature = ({
  link = {
    label: 'Return to Dashboard',
    path: 'Payments',
  },
  route,
  ...restProps
}) => {
  const { name } = route;
  const { pageHeading, subHeading } = pathnameDictionary[name] || pathnameDictionary.default;

  return (
    <StyledView>
      <Message
        body={subHeading}
        icon={errorStorm}
        link={link}
        title={pageHeading}
        {...restProps}
      />
    </StyledView>
  );
};

UnavailableFeature.propTypes = {
  link: T.shape({
    label: T.string,
    path: T.string,
  }),
  route: T.object.isRequired,
};

export default UnavailableFeature;
